if (!customElements.get("supply-widget")) {
  customElements.define(
    "supply-widget",
    class SupplyWidget extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        this.options = this.querySelectorAll("[data-quantity-option]");
        this.quantityInput = this.getQuantityInput();
        this.container = this.closest("[data-section-id]");
        this.isSyncingQuantity = false;
        this.quantityInputs = [];
        this.onExternalQuantityChange = (event) => {
          this.syncBoxSelectionFromQuantity(event.target?.value);
        };

        this.bindOptionEvents();
        this.bindQuantityInputs();
        this.syncBoxSelectionFromQuantity(this.quantityInput?.value);
        this.setInitialOption();
        this.bindVariantChange();
      }

      getQuantityInput() {
        const inputs = this.closest("section")?.querySelectorAll(
          "product-form input[name='quantity']",
        );

        return inputs?.[0] || null;
      }

      bindOptionEvents() {
        this.options.forEach((option) => {
          option.addEventListener("click", () => {
            this.handleOptionSelect(option);
          });
        });
      }

      setInitialOption() {
        const selectedOption = this.querySelector(".wt-quantity-widget__option--selected");

        if (selectedOption) {
          this.handleOptionSelect(selectedOption);
        }
      }

      syncBoxSelectionFromQuantity(rawQuantity) {
        const sectionId = this.closest("[data-section-id]")?.dataset?.sectionId;
        if (!sectionId || this.isSyncingQuantity) {
          return;
        }

        const quantity = Number.parseInt(rawQuantity, 10);
        if (!Number.isFinite(quantity) || quantity <= 0) {
          return;
        }

        const match = [...this.options].find(
          (option) => Number(option.dataset.quantity) === quantity,
        );

        if (match) {
          this.handleOptionSelect(match);
          return;
        }

        this.options.forEach((item) => {
          item.classList.remove("wt-quantity-widget__option--selected");
          item.setAttribute("aria-pressed", "false");
        });
        delete this.dataset.selectedQuantity;
        this.publishQuantityUpdate(sectionId, quantity);
      }

      handleOptionSelect(option) {
        const selectedQuantity = Number(option?.dataset?.quantity);
        const sectionId = this.closest("[data-section-id]")?.dataset?.sectionId;

        if (!Number.isFinite(selectedQuantity) || selectedQuantity <= 0 || !sectionId) {
          return;
        }

        this.options.forEach((item) => {
          item.classList.remove("wt-quantity-widget__option--selected");
          item.setAttribute("aria-pressed", "false");
        });

        option.classList.add("wt-quantity-widget__option--selected");
        option.setAttribute("aria-pressed", "true");
        this.dataset.selectedQuantity = String(selectedQuantity);

        this.updateFormQuantity(selectedQuantity);
        this.publishQuantityUpdate(sectionId, selectedQuantity);
      }

      updateFormQuantity(quantity) {
        const inputs = this.closest("section")?.querySelectorAll(
          "product-form input[name='quantity']",
        );

        if (!inputs || inputs.length === 0) {
          return;
        }

        this.isSyncingQuantity = true;
        inputs.forEach((input) => {
          input.value = String(quantity);
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
        this.isSyncingQuantity = false;
      }

      publishQuantityUpdate(sectionId, quantity) {
        publish(PUB_SUB_EVENTS.quantityUpdate, {
          data: { sectionId, quantity },
        });
      }

      bindQuantityInputs() {
        if (this.quantityInputs?.length) {
          this.quantityInputs.forEach((input) => {
            input.removeEventListener("change", this.onExternalQuantityChange);
            input.removeEventListener("input", this.onExternalQuantityChange);
          });
        }

        const inputs = this.closest("section")?.querySelectorAll(
          "product-form input[name='quantity']",
        );

        if (!inputs?.length) {
          this.quantityInputs = [];
          return;
        }

        this.quantityInputs = [...inputs];
        inputs.forEach((input) => {
          input.addEventListener("change", this.onExternalQuantityChange);
          input.addEventListener("input", this.onExternalQuantityChange);
        });
      }

      bindVariantChange() {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const wrapper = this.closest("[data-section-id]");
          const sectionId = wrapper?.dataset?.sectionId;
          const originalSectionId = wrapper?.dataset?.originalSectionId;

          if (sectionId && e.data.sectionId !== sectionId && e.data.sectionId !== originalSectionId) {
            return;
          }

          const parsedHTML = e.data.html.querySelector(".wt-quantity-widget__container");
          const currentContainer = this.querySelector(".wt-quantity-widget__container");

          if (!parsedHTML || !currentContainer) {
            return;
          }

          currentContainer.innerHTML = parsedHTML.innerHTML;
          this.options = this.querySelectorAll("[data-quantity-option]");
          this.bindOptionEvents();
          this.bindQuantityInputs();
          this.quantityInput = this.getQuantityInput();
          this.syncBoxSelectionFromQuantity(this.quantityInput?.value);
          this.setInitialOption();
        });
      }

      disconnectedCallback() {
        this.quantityInputs?.forEach((input) => {
          input.removeEventListener("change", this.onExternalQuantityChange);
          input.removeEventListener("input", this.onExternalQuantityChange);
        });

        if (typeof this.unsubscribeVariantChange === "function") {
          this.unsubscribeVariantChange();
        }
      }
    },
  );
}
